module.exports = __webpack_public_path__ + "static/media/react-logo.edfce17a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/react-logo.svg
// module id = 83
// module chunks = 0